import Vue from 'vue'

// 防止按钮多次点击
Vue.directive("preventReClick",{
  bind(el,binding) {
    el.addEventListener('click', () => {
        if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
                el.disabled = false
            }, binding.value || 1500)
        }
    })
  }
})





// WEBPACK FOOTER //
// ./src/utils/directive.js